import { atlas } from '~/services/serviceInstances';

import {
  ListPlaybooksApiArg,
  ListPlaybooksResponse,
} from '../../types/playbooks/playbooks';

export const getPlaybooks = async ({
  search,
  workflowId,
  status,
}: ListPlaybooksApiArg = {}): Promise<ListPlaybooksResponse> => {
  const params: Record<string, string | number> = {};
  // TODO move the component layer once pagination is implemented
  params['page[limit]'] = 0;
  if (search) {
    params.search = search;
  }

  if (workflowId) {
    params['workflow_id'] = workflowId;
  }

  if (status) {
    params.status = status;
  }

  return atlas.get<ListPlaybooksResponse>('playbooks', { params });
};
